export default [
    {
        path: '/hr/payrolls',
        name: 'payrolls',
        props: true,
        component: () => import('@/views/hr/payrolls/index.vue'),
        meta: {
            pageTitle: 'Payrolls',
            breadcrumb: [
                {
                text: 'Payrolls',
                active: true,
                },
            ],
        },
    },
    {
        path: '/hr/payrolls/add',
        name: 'create-payrolls',
        component: () => import('@/views/hr/payrolls/create.vue'),
        meta: {
            pageTitle: 'Create Payrolls',
            breadcrumb: [
                {
                text: 'Payrolls',
                to: { name: 'payrolls' },
                },
                {
                text: 'Create Payrolls',
                active: true,
                },
            ],
        },
    },
    {
        path: '/hr/payrolls/:id',
        name: 'detail-payrolls',
        props: true,
        component: () => import('@/views/hr/payrolls/detail.vue'),
        meta: {
            pageTitle: 'Detail Payrolls',
            breadcrumb: [
                {
                text: 'Payrolls',
                to: { name: 'payrolls' },
                },
                {
                text: 'Detail Payrolls',
                active: true,
                },
            ],
        },
    },
]